import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import LockIcon from "@mui/icons-material/Lock";
import { BoxProps, Button, Tooltip, useTheme } from "@mui/material";
import { FC } from "react";

import {
  OverviewTableCell,
  OverviewTableCellBody,
} from "../overview-table-cell";

export interface TableEditCellProps {
  textOnHover?: string;
  cardProps?: BoxProps;
  cellSx?: BoxProps;
  onClick?: () => void;
  isLocked?: boolean;
  hidden?: boolean;
}

/** Chip that shows the updated status of the project */
export const TableEditCell: FC<TableEditCellProps> = ({
  textOnHover,
  cardProps = {},
  cellSx = {},
  onClick,
  isLocked = false,
  hidden = false,
}) => {
  const theme = useTheme();
  const sx = {
    color: theme.palette.primary.contrastText,
    backgroundColor: "#ffffff",
    width: "25px",
    height: "25px",
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
  };

  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "common.white",
            color: "black",
            border: "1px solid",
            borderColor: theme.palette.secondary.main,
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: 400,
            p: 1,
          },
        },
      }}
      disableInteractive
      title={textOnHover}
    >
      <OverviewTableCell
        sx={{ ...cellSx, ...(hidden ? { display: "none" } : {}) }}
      >
        <OverviewTableCellBody
          sx={{
            height: "30px",
            display: "flex",
            justifyContent: "center",
            ...cardProps.sx,
          }}
        >
          <Button
            disabled={isLocked}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClick?.();
            }}
          >
            {isLocked ? <LockIcon sx={sx} /> : <CreateOutlinedIcon sx={sx} />}
          </Button>
        </OverviewTableCellBody>
      </OverviewTableCell>
    </Tooltip>
  );
};

export default TableEditCell;
